import React, { useState } from "react";
import { db } from "../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc
} from "firebase/firestore";
import jsPDF from "jspdf";
import "../styles/CertificateLookup.css";
 // This component allows users to look up a certificate using a unique code and download it as a PDF.
function CertificateLookup() {
  const [code, setCode] = useState("");
  const [details, setDetails] = useState(null);
  const [error, setError] = useState("");
// This state variable holds the error message if any error occurs during the search.
  const handleSearch = async () => {
    setError("");
    setDetails(null);
    try {
      const q = query(collection(db, "Participations"), where("vccode", "==", code));
      const querySnapshot = await getDocs(q);
      if (querySnapshot.empty) {
        setError("No certificate found.");
        return;
      }
      const participationDoc = querySnapshot.docs[0];
      const data = participationDoc.data();

      let opportunityData = {};
      if (data.opportunity) {
        const oppSnap = await getDoc(data.opportunity);
        opportunityData = oppSnap.exists() ? oppSnap.data() : {};
      }

      let userData = {};// This state variable holds the user data associated with the certificate.
      if (data.volunteer) {
        const userSnap = await getDoc(data.volunteer);
        userData = userSnap.exists() ? userSnap.data() : {};
      }

      let providerName = "";
      if (opportunityData.createdBy) {
        const provSnap = await getDoc(opportunityData.createdBy);
        providerName = provSnap.exists() ? provSnap.data().name : "Unknown";
      }

      setDetails({
        userName: userData.name || "No Name",
        opportunityTitle: opportunityData.title || "No Title",
        date: new Date(opportunityData.date?.seconds * 1000).toLocaleString(),
        hours: opportunityData.hours || "Not specified",
        providerName,
        vccode: data.vccode
      });
    } catch (err) {
      console.error(err); // Log the error to the console for debugging
      setError("An error occurred.");
    }
  };

  const handleDownload = () => { // This function generates a PDF certificate using the details retrieved from Firestore.
    if (!details) return;


    const docPDF = new jsPDF();
    docPDF.setFontSize(18);
    docPDF.text("Certificate of Participation", 20, 20);
    docPDF.setFontSize(12);
    docPDF.text(`Name: ${details.userName}`, 20, 40);
    docPDF.text(`Opportunity: ${details.opportunityTitle}`, 20, 50);
    docPDF.text(`Date: ${details.date}`, 20, 60);
    docPDF.text(`Hours: ${details.hours}`, 20, 70);
    docPDF.text(`Provided by: ${details.providerName}`, 20, 80);
    docPDF.text(`Code: ${details.vccode}`, 20, 100);
    docPDF.save(`Certificate-${details.vccode}.pdf`);
  };

  return (
    <div className="page-container">
      <div className="card">
        <img src="/MoeenLogoReact.png" alt="Moeen Logo" className="logo" />
        <h2>🔍 Certificate Lookup</h2>

        <div className="search-container">
          <input
            type="text"
            placeholder="Enter Certificate Code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <button onClick={handleSearch}>Search</button>
        </div>

        {error && <p className="error">{error}</p>}

        {details && (
          <div className="details">
            <h3>📄 Certificate Found:</h3>
            <p><strong>Name:</strong> {details.userName}</p>
            <p><strong>Opportunity:</strong> {details.opportunityTitle}</p>
            <p><strong>Date:</strong> {details.date}</p>
            <p><strong>Hours:</strong> {details.hours}</p>
            <p><strong>Provider:</strong> {details.providerName}</p>
            <p><strong>Certificate Code:</strong> {details.vccode}</p>
            <button onClick={handleDownload}>Download PDF</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default CertificateLookup;
